import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Nav from './components/Nav';
import Footer from './components/Footer';

import Home from './pages/Home';
import Financing from './pages/Financing';
import Investors from './pages/Investors';
import Sell from './pages/Sell';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Partners from './pages/Partners';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Security from './pages/Security';

import './styles/marketing.css';

/* Scroll back to top when route changes — keeps the editorial pacing intact. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <main>
        <Routes>
          <Route path="/"             element={<Home />} />
          <Route path="/financing"    element={<Financing />} />
          <Route path="/investors"    element={<Investors />} />
          <Route path="/sell"         element={<Sell />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing"      element={<Pricing />} />
          <Route path="/about"        element={<About />} />
          <Route path="/partners"     element={<Partners />} />
          <Route path="/privacy"      element={<Privacy />} />
          <Route path="/terms"        element={<Terms />} />
          <Route path="/security"     element={<Security />} />
          {/* Fallback — anything unknown sends owners home. */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
